module.exports = __webpack_public_path__ + "static/board-23-233db7a18d691519e0d9d73f9554387d.jpg";